<template>
    <div>
        <div class="profile-image-uploader-wrapper"
             @drop.prevent="loadImage($event)"
             @dragover.prevent>
            <div v-if="image" class="profile-image-uploader">
                <div class="img-buttons">
                    <label class="p-0" style="cursor: pointer;">
                        <input style="display: none" type="file" name="file" accept="image/*" @change="loadImage($event)"
                               :multiple="true" :disabled="loading.upload" ref="input"/>
                        <span><inline-svg src="/assets/img/icons/edit-circle-white.svg"></inline-svg></span>
                    </label>
                </div>
                <img :src="image">
            </div>
            <div v-else class="profile-image-uploader">
                <template>
                    <label class="p-0" style="cursor: pointer;">
                    <input style="display: none" type="file" name="file" accept="image/*" @change="loadImage($event)"
                           :multiple="true" :disabled="loading.upload" ref="input"/>
                        <span><inline-svg src="/assets/img/icons/profile-img-upload.svg"></inline-svg></span>
                    </label>
                </template>
            </div>
            <a v-if="image" class="link-black" href="#" @click="removeImage(image)">Delete</a>
        </div>
        <span v-if="hint">💡 Tip: {{this.hint}}</span>
        <modal name="cropImageModal" height="auto" width="650px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header d-flex flex-1 align-items-center justify-content-start gap-2">
                    <inline-svg src="/assets/img/icons/scissors-cut.svg"></inline-svg>
                    <div class="d-flex flex-column">
                        <h4 class="modal-title">Crop image</h4>
                    </div>
                </div>
                <div class="modal-body d-flex flex-column align-items-center pt-3 pb-4" :class="{'loading': loading.image}">
                    <div class="p-1" style="height: 400px; width: 600px">
                        <cropper ref="cropper"
                                 :stencil-props="{
                                    aspectRatio: 1,
                                    }"
                                 check-orientation
                                 default-boundaries="fill"
                                 backgroundClass="background"
                                 image-restriction="none"
                                 stencil-component="circle-stencil"
                                 :src="uploadedImage" />
                    </div>
                </div>
                <div class="divider --top-12"></div>
                <div class="modal-footer">
                    <btn class="btn-outline-light btn-lg" @click="reset">Cancel</btn>
                    <btn class="btn-primary btn-lg" :loading="loading.upload" @click="uploadImage">Save</btn>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import draggable from 'vuedraggable';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import { saveAs } from 'file-saver';

export default {
    name: 'ProfileImageUploader',
    props: ['value', 'target', 'target_id', 'editable', 'hint', 'image_type', 'is_user_profile'],
    components: {draggable, Cropper},
    computed: {
        ...mapState({
            languages: (state) => state.languages,
        }),
    },
    data() {
        return {
            loading: {
                image: false,
                upload: false,
                save: false,
                remove: false,
            },
            id: '',
            uploadedImage: null,
            image: '',
            edited: false,
        };
    },
    mounted() {
        this.id = this._uid;
        this.image = this.value
    },
    watch: {
        value(a) {
            this.image = a;
        },
        image(image) {
            this.$emit('input', image);
        }
    },
    methods: {
        crop() {
            const { canvas } = this.$refs.cropper.getResult();
            canvas.toBlob((blob) => {
                saveAs(blob);
            }, this.uploadedImage);
        },
        reset() {
            this.$modal.hide('cropImageModal')
            this.uploadedImage = null;
        },
        loadImage(event) {
            this.loading.image = true;
            // Reference to the DOM input element
            const { files } = event.target;
            // Ensure that you have a file before attempting to read it
            if (files && files[0]) {
                // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
                if (this.uploadedImage) {
                    URL.revokeObjectURL(this.uploadedImage);
                }
                // 2. Create the blob link to the file to optimize performance:
                const blob = URL.createObjectURL(files[0]);
                // Create a new FileReader to read this image binary data
                const reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.image" refers to the image of Vue component
                    this.uploadedImage = blob;
                    this.loading.image = false;
                };
                reader.onerror = (e) => {
                    this.loading.image = false;
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsArrayBuffer(files[0]);
                this.$modal.show('cropImageModal')
            }
        },
        destroyed() {
            // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
            if (this.uploadedImage) {
                URL.revokeObjectURL(this.uploadedImage);
            }
        },
        uploadImage(e) {
            this.loading.upload = true;
            const { canvas } = this.$refs.cropper.getResult();
            if (canvas) {
                const formData = new FormData();
                canvas.toBlob((blob) => {
                    formData.append('file', blob);
                    if (this.image_type !== null) {
                        formData.append('type', this.image_type);
                    }
                    formData.append('old_image', this.image);
                    formData.append('is_user_profile', this.is_user_profile);
                    this.$http.post('/upload-file', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        emulateJSON: true,
                        files: true,
                    })
                        .then((res) => {
                            this.loading.upload = false;
                            this.$modal.hide('cropImageModal');
                            this.uploadedImage = null;
                            this.image = res.body;
                            this.edited = false;
                            this.$forceUpdate();
                    })
                        .catch((error) => {
                            this.edited = false;
                            this.loading.upload = false;
                        });
                }, 'image/jpeg');
            }
        },
        removeImage(image) {
            const self = this;
            this.$dialog.confirm('Are you sure you want to delete the image?', {
                okText: 'Yes',
                cancelText: 'No',
            })
                .then(() => {
                    self.loading.remove = true;
                    self.$http.post('/delete-file', {filePath: image, is_user_profile: this.is_user_profile})
                        .then(function (res) {
                            self.image = null;
                            self.uploadedImage = null;
                            self.loading.remove = false;
                            self.$forceUpdate();
                        })
                        .catch((res) => {
                            self.loading.remove = false;
                        });
                });
            this.$forceUpdate();
        },
        editImage(image) {
            this.edited = true;
            this.uploadedImage = image;
            this.$modal.show('cropImageModal');
        },
    },
};
</script>
